import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useGET_plopReportByIdQuery, usePUT_plopReportSendParentsMutation, usePUT_plopReportSendStudentMutation } from 'redux/api/plopApi'
import { useNavigate } from 'react-router-dom'
import { Accordion, AccordionDetails, AccordionSummary, Button, Link, Typography } from '@mui/material'
import { ArrowLeft, ExpandMore, Print } from '@mui/icons-material'
import { formatDateTime, printDiv } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

interface IProps {
  id: string
}

const PlopReport: FC<IProps> = ({id}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const backToSlug ='/plop-report-records'
  const { data } = useGET_plopReportByIdQuery(id)
  const user = useSelector((state: RootState) => state['user'].user)

  const [
    sendStudent,
  ] = usePUT_plopReportSendStudentMutation()

  const [
      sendParents,
    ] = usePUT_plopReportSendParentsMutation()
  
  const slideProps = {
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: { enter: 225, exit: 195 }
    };

  return (
    <>{data && data.student && 
      <>
          <div style={{ display: 'flex' , width: '100%' }}>
            <Link onClick={() => navigate(backToSlug)} className="setup-link">
              <Typography sx={{ display: 'flex', alignItems: 'center', fontWeight: '400', fontSize: '1rem' }}>
                <ArrowLeft sx={{ fontSize: '1.5em' }} />
                {t('common.all-reports')}
              </Typography>
            </Link>

            <Link onClick={() => printDiv('info-table')} className="setup-link" sx={{ marginLeft: 'auto' }}>
              <Typography sx={{ display: 'flex', alignItems: 'center', fontWeight: '400', fontSize: '1rem' }}>
                <Print sx={{ fontSize: '1em' }} />
                {t('common.print')}
              </Typography>
            </Link>
          </div>


            <h1>{`${t('common.plop-reports')} - ${data.student.title}`}</h1>


            <div>
              <table className="info-table" style={{marginBottom: '20px'}}><tbody>
                <tr><td>{ t('common.date-of-performance-evaluation') }:</td><td>{ formatDateTime(data.created_at) }</td></tr>
                <tr><td>{ t('common.evaluated-by') }:</td><td>{ data.evaluated_by  }</td></tr>
              </tbody></table>
              {data.category_answers.map(c => <Accordion  
                TransitionProps={slideProps} 
                defaultExpanded={false}
                key={c.id}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                      <div style={{ display:'flex',width:'100%',gap:'10px',fontSize: '14px' }}>
                        <div style={{ width: '400px', maxWidth: '40%' }}>{`${c.title}`}</div>
                        <div>{t('common.result')}: {c.score}%</div>
                      </div>
                </AccordionSummary>
                <AccordionDetails>
                  <table className='plop-answers-table'>
                    {c.answers.map(a => <tr style={{
                      fontSize: '14px'}}>
                      <td style={{ width: '400px', maxWidth: '40%' }}>{a.title}</td>
                      <td><i>{a.importance} - {t(`plop-importance-options.${a.importance}`)}</i></td>
                      <td><b>{t(`plop-point-options.${a.points}`)}</b></td>
                    </tr>)}
                  </table>
                </AccordionDetails>
              </Accordion>)}
              <div style={{ marginTop: '40px', fontSize: '20px', fontWeight: '400'}}>{t('common.overall-performance')}: {data.baseline_score}%</div>
            </div>

            <div id="info-table" style={{ display: 'none' }}>

              <h2>{t('rti.plop')} - { data.student?.title }</h2>
              <table style={{marginBottom: '20px'}}><tbody>
                <tr>
                  <td style={{textAlign:'right', paddingBottom: '10px'}}>{ t('common.date-of-performance-evaluation') }:</td>
                  <td style={{paddingBottom: '10px'}}>{ formatDateTime(data.created_at) }</td>
                </tr>
                <tr>
                  <td style={{textAlign:'right', paddingBottom: '10px'}}>{ t('common.evaluated-by') }:</td>
                  <td style={{paddingBottom: '10px'}}>{ data.evaluated_by}</td>
                </tr>
              </tbody></table>


              {data.category_answers.map(c =>  <div style={{ marginBottom: '10px', paddingBottom: '10px', borderBottom: '1px solid #ccc'}}>        
                  <div style={{ display:'flex', width:'100%', marginBottom: '10px', gap:'10px',fontSize: '14px' }}>
                        <div><u>{`${c.title}`}</u></div>
                        <div>{t('common.result')}: {c.score}%</div>
                  </div>
                  <table>
                      {c.answers.map(a=> <tr style={{
                        fontSize: '12px'}}>
                        <td style={{ paddingBottom: '10px' }}>{a.title}</td>
                        <td style={{ paddingBottom: '10px' }}><i>{a.importance} - {t(`plop-importance-options.${a.importance}`)}</i></td>
                        <td style={{ paddingBottom: '10px' }}><b>{t(`plop-point-options.${a.points}`)}</b></td>
                      </tr>)}
                  </table>
                </div>
              )}


            </div>
          
            {!['parent', 'student'].includes(user.role) && <div style={{ marginTop: '20px', textAlign: 'right'  }}>
                  <Button
                        variant='contained'
                        color='primary'
                        onClick={() => sendStudent(id)}
                        disabled={!!data.is_sent_to_student}
                      >
                        {`${t('common.send-to-student')}`}  
                  </Button>
                  
                  <Button
                        variant='contained'
                        color='primary'
                        onClick={ () => { sendParents(id) } }
                        sx={{ marginLeft: '10px' }}
                        disabled={!!data.is_sent_to_parents}
                      >
                        {`${t('common.send-to-parents')}`}
                  </Button>
            </div>}
      </>
    }</>
  )
}

export default PlopReport

